import {FC, ReactNode} from 'react';
import clsx from 'clsx';

export type SideBySideProps = {
    children: ReactNode;
    className?: string;
    spacing?: 'sm';
};

const SideBySide: FC<SideBySideProps> = ({children, className, spacing}) => (
    <div className={clsx('side-by-side', spacing === 'sm' && 'sm', className)}>
        {children}
    </div>
);

export default SideBySide;
